// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6a541d2d","971":"1b620e34"}[chunkId] + ".chunk.js";
};